import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { PenLine, Repeat, Ear, BarChart3 } from "lucide-react";
import { useRoom } from "../../lib/zhuyinRoom";
import { Grouped, MiniCard, RoomShell } from "../../components/zhuyin/RoomUI";

const MODES = [
  ["trace", "只練描寫", "照著筆順一筆一筆寫", PenLine, "#2E7D32"],
  ["marathon", "連續練習 37 個", "看、聽、寫，一個接一個", Repeat, "#C83E2B"],
  ["quiz", "聽音選注音", "聽一聽，找出對的注音", Ear, "#1D6FB8"],
  ["progress", "我的注音進度", "看看學會了哪些", BarChart3, "#B45309"],
];

export default function ZhuyinRoom() {
  const nav = useNavigate();
  const { cards } = useRoom();
  const mastered = cards?.filter((z) => z.status === "mastered").length || 0;
  return (
    <RoomShell title="注音練習館" back="/halls" testid="zhuyin-room-page"
      right={<span className="h-12 px-4 rounded-full bg-white border-2 border-[#b9dcf0] font-round text-lg text-[#14507f] flex items-center" data-testid="room-mastered-count">學會 {mastered} / {cards?.length || 37}</span>}>
      <p className="font-round text-xl text-stone-600 mb-6">三十七個注音朋友都在這裡！點一張卡片，聽聽它的聲音、學口訣、看筆順，再描一描。</p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10" data-testid="room-modes">
        {MODES.map(([key, name, sub, Icon, color], i) => (
          <motion.button key={key} data-testid={`room-mode-${key}`} onClick={() => nav(`/zhuyin/${key}`)} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }}
            whileHover={{ y: -4 }} className="rounded-[1.75rem] bg-white border-2 p-5 text-left shadow-sm" style={{ borderColor: `${color}55` }}>
            <span className="w-14 h-14 rounded-2xl flex items-center justify-center text-white mb-3" style={{ background: color }}><Icon size={28} /></span>
            <div className="font-serif-tc text-2xl font-black" style={{ color }}>{name}</div>
            <div className="font-round text-stone-500 mt-1">{sub}</div>
          </motion.button>
        ))}
      </div>
      {cards && (
        <Grouped cards={cards} render={(list) => (
          <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-8 gap-3">
            {list.map((z) => <MiniCard key={z.symbol} z={z} onClick={() => nav(`/zhuyin/s/${encodeURIComponent(z.symbol)}`)} testid={`room-card-${z.symbol}`} />)}
          </div>
        )} />
      )}
    </RoomShell>
  );
}
